<template>
  <div id="app">
    <!--
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#">home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">tags</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">contact</a>
          </li>
        </ul>
      </div>
    </nav>
    -->
    <div id="content">
      <div class="block">
        david schöpf
        <p id="job-title">IT engineer</p>
      </div>
      <div id="tags" class="block">
          <!--
            <span v-for="item in items" :key="item.message" class="badge badge-light">
              #{{ item }}
            </span>
          -->
      </div>
      <div id="links">
        <a href="https://stackshare.io/davidschoepf/my-stack#stack"># TechStack</a>
      </div>
    </div>

  </div>


</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  data() {
    return {
        items: [
          'VMware', 'PHP', 'C#', 'Linux', 'Vue', 'Windows Server', 'bash', 'HA', 
          'apache', 'nginx', 'Docker', 'gitlab-ci', 'mysql', 'laravel', 'js', 'npm'
      ]
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:black;
  height: 100%;
  width:100%;
  a { 
    text-decoration: none; 
    color:black;
  } 
}

@media (prefers-color-scheme: dark) {
  /*:root {
    --body-bg: #212529;
    --body-color: #6c757d;
    --link-color: #dee2e6;
    --link-color-hover: #fff;
  }
  */
  #app {
    background-color:hsl(120, 2%, 9%);
    color:white;
    a { 
      color:white;
    } 
  }
}

#content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width:100%;
  text-align:center;
  font-size:350%;

  #job-title {
    font-size:40%;
    margin:0;
    text-transform: lowercase;
  }

  #links {
    font-size:30%;
    text-decoration: none;
    margin-top:1em;
    
    a {
      color: #666;
      transition: all 0.3s ease;
    }

    a:hover {
      color: #222;
      text-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    }

  } 
}

#tags {
  font-size:30%;
}

.badge {
  margin: 10px;
}


</style>
